import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import LineChartContainer from '@/components/charts/plausible/LineChartContainer';
import { getCurrentLanguage } from '@/i18n/i18n';
import template from './Home.vue';

@Component({
	mixins: [template],
	components: {
		LineChartContainer
	}
})
export default class Home extends Vue {
	options = {
		responsive: true,
		maintainAspectRatio: false
	};

	amountOfQRCodeScans: object[] = [];

	amountOfQRCodeScansGoogle: object[] = [];

	get lang(): string {
		return getCurrentLanguage().locale;
	}

	created(): void {
		this.amountOfQRCodeScans = [
			{
				metrics: 'pageviews',
				filters: `event:page==projects/${this.$route.params.Pid}/qrcodes/*/view`
			},
			{
				metrics: 'visitors',
				filters: `event:page==projects/${this.$route.params.Pid}/qrcodes/*/view`
			}
		];
	}
}
